import { ObjectId } from "@novorender/data-js-api";

import { procoreClient } from "./client";

/** BIM Search DB API resolve response — `data[i]` pairs with request index `i`; `null` if unresolved. */
interface BimResolveInstanceIdsResponse {
    data: (string | null)[];
}

interface BimResolveObjectIdsResponse {
    data: (ObjectId | null)[];
}

function resolveUrl(params: { companyId: number; projectId: number; sceneId: string; sceneVersionId: string }): string {
    return `/rest/v2.0/companies/${params.companyId}/projects/${params.projectId}/bim/scenes/${params.sceneId}/versions/${params.sceneVersionId}/resolve`;
}

/**
 * Map internal object IDs to Procore/InstanceId strings.
 * Response order matches `objectIds`; `null` means the ID could not be resolved.
 */
export async function procoreResolveObjectIdsToInstanceIds(params: {
    companyId: number;
    projectId: number;
    sceneId: string;
    sceneVersionId: string;
    objectIds: ObjectId[];
    signal?: AbortSignal;
}): Promise<(string | null)[]> {
    if (params.objectIds.length === 0) {
        return [];
    }

    const { data } = await procoreClient<BimResolveInstanceIdsResponse>(resolveUrl(params), {
        method: "POST",
        body: { object_ids: params.objectIds },
        headers: {
            Accept: "application/json",
        },
        signal: params.signal,
    });

    return data;
}

/**
 * Map Procore instance id strings to internal object IDs.
 * Response order matches `instanceIds`; `null` means the ID could not be resolved.
 */
export async function procoreResolveInstanceIdsToObjectIds(params: {
    companyId: number;
    projectId: number;
    sceneId: string;
    sceneVersionId: string;
    instanceIds: string[];
    signal?: AbortSignal;
}): Promise<(ObjectId | null)[]> {
    if (params.instanceIds.length === 0) {
        return [];
    }

    const { data } = await procoreClient<BimResolveObjectIdsResponse>(resolveUrl(params), {
        method: "POST",
        body: { instance_ids: params.instanceIds },
        headers: {
            Accept: "application/json",
        },
        signal: params.signal,
    });

    return data;
}
